import React from 'react';

import { SwitchProps as BSASwitchProps, SwitchSize } from 'antd/lib/switch';
import { Switch as BsaSwitch } from 'bsa-ui';
import cn from 'classnames';

import styles from './Switch.less';

type BaseBSASwitchProps = Omit<BSASwitchProps, 'size'>;

interface SwitchProps extends BaseBSASwitchProps {
  checkedColor?: 'scouting-red' | 'default' | 'information-blue';
  size?: 'large' | SwitchSize;
  id?: string;
}

const Switch: React.FC<SwitchProps> = ({
  className,
  size,
  checkedColor = 'scouting-red',
  ...rest
}) => {
  const classNames = cn(
    styles[checkedColor],
    {
      [styles.large]: size === 'large',
    },
    className,
  );

  return (
    <BsaSwitch
      className={classNames}
      size={size === 'large' ? 'default' : size}
      {...rest}
    />
  );
};

export default Switch;
